import { SILENT_RECONNECT_ATTEMPTS } from "./constants";

const BASE_DELAY_MS = 1_000;
const MAX_DELAY_MS = 30_000;

export type ReconnectDecision = {
  shouldRetry: boolean;
  showBanner: boolean;
  delayMs: number;
};

/**
 * `attempt` = quantas tentativas de reconexao ja foram feitas (0 na primeira queda).
 * As duas primeiras sao silenciosas; a partir dai o banner aparece e a reconexao
 * continua em segundo plano, indefinidamente, com backoff exponencial limitado.
 */
export const decideReconnect = (attempt: number): ReconnectDecision => ({
  shouldRetry: true,
  showBanner: attempt >= SILENT_RECONNECT_ATTEMPTS,
  delayMs: Math.min(BASE_DELAY_MS * 2 ** attempt, MAX_DELAY_MS),
});
